/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Sort_Library_AlphabeticallyInputs */

const en_mobile_sort_library_alphabetically = /** @type {(inputs: Mobile_Sort_Library_AlphabeticallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort Library A–Z`)
};

const es_mobile_sort_library_alphabetically = /** @type {(inputs: Mobile_Sort_Library_AlphabeticallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar biblioteca A–Z`)
};

/**
* | output |
* | --- |
* | "Sort Library A–Z" |
*
* @param {Mobile_Sort_Library_AlphabeticallyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_sort_library_alphabetically = /** @type {((inputs?: Mobile_Sort_Library_AlphabeticallyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Sort_Library_AlphabeticallyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_sort_library_alphabetically(inputs)
	return en_mobile_sort_library_alphabetically(inputs)
});